import { DcBaseComponent } from '@deleteagency/dc';
import { deviceObserver } from '@deleteagency/device-observer';
import eventBus from 'general/js/events/bus';

const ACTIVE_CLASS = 'is-active';
const EVENT_NEW_ACCORDION_OPENS = 'new-accordion-opens';

export default class AccordionComponent extends DcBaseComponent {
    static getNamespace() {
        return 'accordion';
    }

    static getRequiredRefs() {
        return ['btn', 'container', 'content'];
    }

    onInit() {
        this.isActive = false;
        if (this.options.is && this.options.viewport) {
            if (this._isCorrect()) this._init();
            this.unsubscribe = deviceObserver.subscribeOnChange(this._onChangeViewport);
            if (this.options.isOnlyOneOpened) {
                eventBus.addListener(EVENT_NEW_ACCORDION_OPENS, this._onNewAccordionOpens);
            }
        } else this._init();
    }

    _isCorrect = () => deviceObserver.is(this.options.is, this.options.viewport);

    _onChangeViewport = () => {
        const isCorrect = this._isCorrect();
        if (this.inited && !isCorrect) {
            this._destroy();
        } else if (!this.inited && isCorrect) this._init();
    };

    _init = () => {
        this.inited = true;
        this.refs.btn.addEventListener('click', this.onClick);
        this.refs.container.setAttribute('inert', true);
    };

    onClick = () => {
        if (this.isActive) {
            this._close();
        } else {
            this._open();
        }
    };

    _onNewAccordionOpens = (el) => {
        if (!this.element.isEqualNode(el) && this.isActive && this.options.isOnlyOneOpened) {
            this._close();
        }
    };

    _open = () => {
        eventBus.emit(EVENT_NEW_ACCORDION_OPENS, this.element);
        this.isActive = true;
        this.refs.container.removeAttribute('inert');
        const size = this.refs.content.clientHeight;
        this.refs.container.style.maxHeight = size + 'px';
        this.element.classList.add(ACTIVE_CLASS);
        setTimeout(() => {
            this.refs.container.style.maxHeight = 'unset';
        }, 300);
    };

    _close = () => {
        this.isActive = false;
        this.element.classList.remove(ACTIVE_CLASS);
        const size = this.refs.content.clientHeight;
        this.refs.container.style.maxHeight = size + 'px';
        setTimeout(() => {
            this.refs.container.style.maxHeight = '';
            this.refs.container.setAttribute('inert', true);
        }, 20);
    };

    _destroy = () => {
        this.inited = false;
        this.refs.btn.removeEventListener('click', this.onClick);
        this._close();
    };

    onDestroy() {
        if (this.unsubscribe) this.unsubscribe();
        if (this.inited) this.refs.btn.removeEventListener('click', this.onClick);
    }
}
